import _ from 'lodash';
import moment from 'moment';
import { Firebase, callIfFunction, unwrapDoc, goalValueIsSet, unwrapDocs, logAndDispatchErrorForAction, withoutId, getCurrentTimestamp, accountId, organizationId, isProduction, omitDeleted, addKeysAsIds } from './../util';
import { OrganizationRef, SalesCompetencyReviewsRef, SalesCompetencyReviewItemsRevi } from './../util/refs';

import {
  FETCH_SALES_COMPETENCY_REVIEW_ITEMS,

  FETCH_SALES_COMPETENCY_REVIEWS,
  FETCH_SALES_COMPETENCY_REVIEWS_SUCCESS,
  FETCH_SALES_COMPETENCY_REVIEWS_ERROR,

  SAVE_SALES_COMPETENCY_REVIEW,
  SAVE_SALES_COMPETENCY_REVIEW_SUCCESS,
  SAVE_SALES_COMPETENCY_REVIEW_ERROR,

  FETCH_SALES_COMPETENCY_REVIEW,
  FETCH_SALES_COMPETENCY_REVIEW_SUCCESS,
  FETCH_SALES_COMPETENCY_REVIEW_ERROR,

} from './types';

export function fetchSalesCompetencyReview(reviewId, callback){

  return dispatch => {
    dispatch({
      type: FETCH_SALES_COMPETENCY_REVIEW
    });

    SalesCompetencyReviewsRef().doc(reviewId).get().then(doc => {

      const thisTalentReview = unwrapDoc(doc);
      const thisTalentReviewStartedOnDate = thisTalentReview.startedOn;
      const sellerId = thisTalentReview.seller;

      //also grab prior review to this...
      SalesCompetencyReviewsRef().where('seller', '==', sellerId).orderBy('startedOn', 'desc').startAfter(thisTalentReviewStartedOnDate).limit(1).get().then(docs => {

        const priorReview = unwrapDocs(docs)[0] || null;

        dispatch({
          type: FETCH_SALES_COMPETENCY_REVIEW_SUCCESS,
          payload: {
            current: thisTalentReview,
            prior: priorReview,
          }
        });

        callIfFunction(callback, thisTalentReview);

      }).catch(err => { logAndDispatchErrorForAction(`Fetch sales competency prior review for review ${reviewId}`, err, dispatch, FETCH_SALES_COMPETENCY_REVIEW_ERROR, callback) });
    }).catch(err => { logAndDispatchErrorForAction(`Fetch sales competency review ${reviewId}`, err, dispatch, FETCH_SALES_COMPETENCY_REVIEW_ERROR, callback) });
  }
}

export function fetchSalesCompetencyReviewItems(callback){
  return dispatch => {
    SalesCompetencyReviewItemsRevi().get().then(doc => {
      dispatch({
        type: FETCH_SALES_COMPETENCY_REVIEW_ITEMS,
        payload: unwrapDoc(doc)
      });

      callIfFunction(callback);
    });
  }
}

export function initializeSalesCompetencyReview(sellerId, callback){

  return dispatch => {

    dispatch({
      type: SAVE_SALES_COMPETENCY_REVIEW,
    });

    //check for existing started review - this could happen if both manager and rep try to begin the review at the EXACT SAME TIME - I.E. Both have navigated to the review page, and click begin before either party has a chance to reload the page
    SalesCompetencyReviewsRef().where('seller', '==', sellerId).where('status', '==', 'inprogress').get().then(inProgressReviewDocs => {

      const inProgressReviews = unwrapDocs(inProgressReviewDocs);
      console.log('inProgressReviews: ', inProgressReviews);

      //if recently started in progress review that hasn't been loaded, begin this review instead
      if(_.size(inProgressReviews) > 0){
        return callIfFunction(callback, _.head(inProgressReviews))
      }
      else{
        //no recently started reviews that haven't been loaded, initialize a new review

        const initialData = {
          status: 'inprogress',
          sellerStatus: 'notstarted',
          reviewerStatus: 'notstarted',
          seller: sellerId,
          reviewer: accountId(),
          startedOn: moment().valueOf(),
          sellerResponses: {},
          reviewerResponses: {},
        }

        SalesCompetencyReviewsRef().add(initialData).then(docRef => {

          const salesCompetencyReviewDataWithId = {
            ...initialData,
            _id: docRef.id,
          };

          dispatch({
            type: SAVE_SALES_COMPETENCY_REVIEW_SUCCESS,
            payload: salesCompetencyReviewDataWithId
          });

          callIfFunction(callback, salesCompetencyReviewDataWithId);

        }).catch(err => { logAndDispatchErrorForAction(`Save new sales competency review for user ${sellerId}`, err, dispatch, SAVE_SALES_COMPETENCY_REVIEW_ERROR, callback) });
      }
    });
  }
}

export function updateSalesCompetencyReview(reviewId, reviewUpdates, isOwnReview, callback){

  return dispatch => {

    dispatch({
      type: SAVE_SALES_COMPETENCY_REVIEW,
    });

    //make sure in progress status is set for appropriate party, as we're making an update
    let updates = {
      ...reviewUpdates,
      lastModified: moment().valueOf(),
      ...(isOwnReview && { sellerStatus: 'inprogress' }),
      ...(!isOwnReview && { reviewerStatus: 'inprogress' }),
    }

    SalesCompetencyReviewsRef().doc(reviewId).update(updates).then(docRef => {

      dispatch({
        type: SAVE_SALES_COMPETENCY_REVIEW_SUCCESS,
        payload: updates
      });

      callIfFunction(callback, updates);

    }).catch(err => { logAndDispatchErrorForAction(`Update existing sales competency review`, err, dispatch, SAVE_SALES_COMPETENCY_REVIEW_ERROR, callback) });
  }
}

export function completeSalesCompetencyReview(reviewId, reviewUpdates, isOwnReview, callback){

  return dispatch => {

    dispatch({
      type: SAVE_SALES_COMPETENCY_REVIEW,
    });

    //get latest version of review - that way we have an update to the second source
    //of the other party's review status, and can set a "final" completed status if necessary
    SalesCompetencyReviewsRef().doc(reviewId).get().then(reviewDoc => {
      const upToDateCopyOfSalesCompetencyReview = unwrapDoc(reviewDoc);

      let updates = {
        ...reviewUpdates,
        lastModified: moment().valueOf(),
      }

      if(isOwnReview){
        updates = {
          ...updates,
          sellerStatus: 'complete',
          ...(upToDateCopyOfSalesCompetencyReview.reviewerStatus === 'complete' && {
            status: 'complete',
            completedOn: moment().valueOf(),
          })
        }
      }
      else{
        updates = {
          ...updates,
          reviewerStatus: 'complete',
          ...(upToDateCopyOfSalesCompetencyReview.sellerStatus === 'complete' && {
            status: 'complete',
            completedOn: moment().valueOf(),
          })
        }
      }

      SalesCompetencyReviewsRef().doc(reviewId).update(updates).then(docRef => {

        const upToDateCopyOfSalesCompetencyReviewWithLastChanges = {
          ...upToDateCopyOfSalesCompetencyReview,
          ...updates
        }

        dispatch({
          type: SAVE_SALES_COMPETENCY_REVIEW_SUCCESS,
          payload: upToDateCopyOfSalesCompetencyReviewWithLastChanges
        });

        callIfFunction(callback, upToDateCopyOfSalesCompetencyReviewWithLastChanges);

      }).catch(err => { logAndDispatchErrorForAction(`Complete existing sales competency review`, err, dispatch, SAVE_SALES_COMPETENCY_REVIEW_ERROR, callback) });
    }).catch(err => { logAndDispatchErrorForAction(`Complete existing sales competency review (on fetching up to date copy)`, err, dispatch, SAVE_SALES_COMPETENCY_REVIEW_ERROR, callback) });
  }
}

export function fetchSalesCompetencyReviewsForSeller(sellerId, callback){
  console.log('fetching sales competency review for user: ', sellerId);

  return dispatch => {

    dispatch({
      type: FETCH_SALES_COMPETENCY_REVIEWS,
    });

    SalesCompetencyReviewsRef().where('seller', '==', sellerId).orderBy('startedOn', 'desc').get().then(docs => {
      const salesCompetencyReviews = unwrapDocs(docs) || [];

      console.log('sales competency review: ', salesCompetencyReviews);

      dispatch({
        type: FETCH_SALES_COMPETENCY_REVIEWS_SUCCESS,
        payload: salesCompetencyReviews
      });

      callIfFunction(callback, salesCompetencyReviews);

    }).catch(err => { logAndDispatchErrorForAction(`Fetch talent reviews for user ${sellerId}`, err, dispatch, FETCH_SALES_COMPETENCY_REVIEWS_ERROR, callback) });
  }
}

export function fetchAllSalesCompetencyReviews(callback){

  return dispatch => {

    dispatch({
      type: FETCH_SALES_COMPETENCY_REVIEWS,
    });

    SalesCompetencyReviewsRef().where('status', '==', 'complete').orderBy('startedOn', 'desc').get().then(docs => {
      const salesCompetencyReviews = unwrapDocs(docs) || [];

      console.log('salesCompetencyReviews: ', salesCompetencyReviews);

      dispatch({
        type: FETCH_SALES_COMPETENCY_REVIEWS_SUCCESS,
        payload: salesCompetencyReviews
      });

      callIfFunction(callback, salesCompetencyReviews);

    }).catch(err => { logAndDispatchErrorForAction(`Fetch all reviews`, err, dispatch, FETCH_SALES_COMPETENCY_REVIEWS_ERROR, callback) });
  }
}



// WEBPACK FOOTER //
// ./src/actions/salesCompetencyReviews.js